import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const CommonOlListObj = {
    colorNumber: '#7927E0',
    list: [
        'Тестирование гипотез по&nbsp;методологии HADI-циклов',
        'Ежедневный мониторинг KPI по каждому источнику и таргетингу',
        'Быстрое принятие решений в&nbsp;соответствии с&nbsp;изменениями в&nbsp;таргетингах и&nbsp;источниках',
        'Одновременное тестирование 3&ndash;5 гипотез для одного сегмента таргетинга',
        'Акцент на&nbsp;целевой аудитории без привязки к&nbsp;источнику трафика',
        'Необычные таргетинги и&nbsp;сегменты. Например, базы данных участников мероприятий/стартапов/посетителей, точечные радиусы, look a&nbsp;like аудитории и&nbsp;прочее',
        'Отдельные креативы для сегментов таргетинга на&nbsp;целевую аудиторию',
    ],
};

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="skolkovo-process">
                <div className="skolkovo-process__container">
                    <div className="skolkovo-process__text-info">
                        <CommonTitle>Процесс</CommonTitle>
                        <CommonUsualText className="skolkovo-process__subtitle">
                            Нам удалось достичь 100% KPI благодаря 7 простым действиям:
                        </CommonUsualText>
                        <CommonOlList CommonOlList={CommonOlListObj} />
                    </div>
                    <div className="skolkovo-process__img">
                        <img src="/images/svg/skolkovo/process__img.svg" alt="" loading="lazy" />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
